import { FC } from 'react';
import { ArrowUpDown } from 'lucide-react';
import { Select } from '../../components/ui/Select';
import type { ServiceSortOption } from '../../types/service.types';

interface ServiceSortDropdownProps {
  value: ServiceSortOption;
  onChange: (value: ServiceSortOption) => void;
}

const sortOptions = [
  { value: 'popular', label: 'Most Popular' },
  { value: 'price-asc', label: 'Price: Low to High' },
  { value: 'price-desc', label: 'Price: High to Low' },
  { value: 'duration-asc', label: 'Duration: Shortest' },
  { value: 'duration-desc', label: 'Duration: Longest' },
  { value: 'name-asc', label: 'Name: A-Z' },
];

export const ServiceSortDropdown: FC<ServiceSortDropdownProps> = ({ value, onChange }) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value as ServiceSortOption);
  };

  return (
    <div className="flex items-center gap-2">
      <ArrowUpDown className="h-4 w-4 text-gray-500 dark:text-slate-400 flex-shrink-0" aria-hidden="true" />
      <Select
        options={sortOptions}
        value={value}
        onChange={handleChange}
        selectSize="sm"
        aria-label="Sort services by"
        containerClassName="min-w-[180px]"
      />
    </div>
  );
};
